import * as React from 'react';
import { Form, Input, Select } from 'antd';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import {
	getFieldChoices,
	isMultiSelectField,
	isMultipleChoiceField,
	templateFieldName,
} from '../../utils/ProjectTemplateUtils';
import { PROJECT_TEMPLATE_FIELD_GROUPS } from '../../constants/ProjectTemplateFields';

// The picked template's custom fields, as inputs on a project form. Required and
// optional groups render identically apart from the rule, and the values are read
// back out on submit by getProjectTemplateDetails.
//
// Only multiple choice gets a control of its own. The other types (text, number,
// currency, date) have always been stored and edited as free text, and swapping in a
// typed control would leave every value authored before the swap unparseable by it.
//
// antd v4 Form.Item, so both project forms (create and edit) and the detail-page
// modal use this as-is.

const FIELD_STYLE = { maxWidth: 640 };

const renderFieldInput = (field) => {
	if (!isMultipleChoiceField(field)) {
		return <Input style={FIELD_STYLE} />;
	}
	const choices = getFieldChoices(field);
	return (
		<Select
			style={FIELD_STYLE}
			allowClear
			showSearch
			optionFilterProp="children"
			// The options come from the field definition itself, not a paged endpoint, so
			// they are all present and client-side filtering is the whole set.
			mode={isMultiSelectField(field) ? 'multiple' : undefined}
			placeholder={isMultiSelectField(field) ? 'Select one or more' : 'Select one'}
		>
			{choices.map((choice) => (
				<Select.Option key={choice} value={choice}>
					{choice}
				</Select.Option>
			))}
		</Select>
	);
};

const ProjectTemplateDetailFields = ({ projectTemplate }) => (
	<>
		{PROJECT_TEMPLATE_FIELD_GROUPS.map((group) =>
			nullSafeGetOrElse(group, projectTemplate, []).map((field) => (
				<Form.Item
					key={`${group}-${field.key}`}
					label={field.key}
					name={templateFieldName(group, field.key)}
					validateTrigger={['onChange', 'onBlur']}
					rules={
						group === 'requiredFields'
							? [{ required: true, message: 'This field is required.' }]
							: []
					}
				>
					{renderFieldInput(field)}
				</Form.Item>
			))
		)}
	</>
);

export default ProjectTemplateDetailFields;
